import { Head, useForm } from '@inertiajs/react'
import { AuthShell, FormError } from '@/components/auth/AuthShell'
import { Button, Field, Label, Input, Checkbox, CheckboxField, Link } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'

interface LoginProps {
  errors: { base?: string }
}

export default function Login({ errors }: LoginProps) {
  const { t } = useTranslations()
  const form = useForm({ email: '', password: '', remember_me: false })

  function submit(event: React.FormEvent) {
    event.preventDefault()
    form.transform((data) => ({ user: data }))
    form.post('/users/sign_in')
  }

  return (
    <AuthShell title={t('auth.sign_in_title')} subtitle={t('auth.sign_in_subtitle')}>
      <Head title={t('auth.sign_in_title')} />
      <FormError message={errors.base} />

      <form onSubmit={submit} className="flex flex-col gap-5">
        <Field>
          <Label>{t('auth.email')}</Label>
          <Input
            type="email"
            name="email"
            autoComplete="email"
            autoFocus
            required
            value={form.data.email}
            onChange={(e) => form.setData('email', e.target.value)}
          />
        </Field>

        <Field>
          <Label>{t('auth.password')}</Label>
          <Input
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={form.data.password}
            onChange={(e) => form.setData('password', e.target.value)}
          />
        </Field>

        <div className="flex items-center justify-between">
          <CheckboxField>
            <Checkbox
              checked={form.data.remember_me}
              onChange={(checked) => form.setData('remember_me', checked)}
            />
            <Label>{t('auth.remember_me')}</Label>
          </CheckboxField>
          <Link href="/users/password/new" className="text-sm font-medium text-text-strong underline">
            {t('auth.forgot_password')}
          </Link>
        </div>

        <Button type="submit" color="brand" disabled={form.processing} className="w-full">
          {t('auth.sign_in')}
        </Button>
      </form>
    </AuthShell>
  )
}
